import { gql } from '@apollo/client';

export default gql`
  fragment ThreadAnswer on ThreadAnswer {
    _id
    content
    user {
      _id
      name
      email
      profilePicture
    }
    edited
    score
    createdAt

    canEdit
    canDelete
    canReport
    canUpvote
    canDownvote
  }
`;
